import React from "react";
import styled from "styled-components";

const CallToAction = ({onJoinClick}) => {
  return (
    <CTAWrapper id="join">
      <h2>Ready to take control of your finances?</h2>
      <CTAButton onClick={onJoinClick}>Join EYE20 GROUP Now</CTAButton>
    </CTAWrapper>
  );
};

const CTAWrapper = styled.section`
  padding: 3rem 2rem;
  text-align: center;
  background-color: #f1f5f9;

  h2 {
    font-size: 1.75rem;
    color: #003366;
    margin-bottom: 1.5rem;
  }
`;

const CTAButton = styled.a`
  padding: 0.75rem 1.5rem;
  background: #28a745;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  cursor:pointer;
`;

export default CallToAction;
